import React from 'react'
import { Link } from 'gatsby'
import axios from 'axios'
import { GoogleReCaptchaProvider, GoogleReCaptcha } from 'react-google-recaptcha-v3';
import { css } from 'emotion';

import Title from './Title';
import SEO from '../components/SEO';
// import MapContainer from '../components/MapContainer';
import firestore from '../utils/firestore';

const main = css({
  '.social': {
    margin: '0.2rem 0'
  },

  '.box:not(.is-grouped-multiline)': {
    padding: '2em 6em',

    '.box': {
      marginBottom: '1em !important'
    },

    '&:nth-child(1)': {
      boxShadow: '0px 0px 4px 0px #6039B5',
      marginTop: '3em',
      background: '#ded8e757',
      label: {
        color: '#6039B5'
      }
    },

    '&:nth-child(2)': {
      boxShadow: '0px 0px 4px 0px #73CE57',
      background: '#d3f0ca57',
      label: {
        color: '#73CE57'
      },
      'textarea:last-child': {
        marginBottom: '1em'
      }
    },
  },

  label: {
    paddingTop: '0.5rem'
  },

  '.selected': {
    background: '#73CE57',

    '&.service': {
      background: '#6039B5',
      color: '#fff'
    }
  },

  '.show': {
    display: 'inline'
  },

  '.hide': {
    display: 'none'
  },

  '.control': {
    '&.submit': {
      textAlign: 'center !important'
    },

    '&.submit button[type="submit"]': {
      color: '#fff',
      padding: '0 4em'
    },

    '& span': {
      marginRight: '5px'
    }
  },

  '.notification': {
    textAlign: 'center',

    '.label': {
      textAlign: 'center',
      fontWeight: 'bold',
      margin: '0 !important'
    },

    '.control': {
      textAlign: 'center',
      margin: '0 !important'
    },
  },

  '.file-upload': {
    color: 'transparent',
    width: '100%'
  },

  '.file-upload::-webkit-file-upload-button': {
    visibility: 'hidden'
  },

  '.file-upload::before': {
    content: '"Seleccione un archivo"',
    display: 'inline-block',
    background: '#73CE57',
    borderRadius: '3px',
    padding: '1em 3em',
    outline: 'none',
    whiteSpace: 'nowrap',
    '-webkit-user-select': 'none',
    cursor: 'pointer',
    color: '#000',
    fontWeight: 'bold',
    textAlign: 'center'
  },

  '.file-upload:disabled::before': {
    background: 'lightgrey',
  },

  '.modal-card-head': {
    backgroundColor: '#C7EBBC',
    paddingBottom: '0'
  },

  '.map-container': {
    position: 'relative',
    height: '60vh',
    width: '100%',
    margin: '1rem 0'
  },

  '.location': {
    marginTop: '1em',
    '.box': {
      padding: '0.5rem !important'
    }
  },

  '.prod-serv': {
    'label + .checkbox': {
      display: 'block'
    }
  },

  figure: {
    margin: '0.5em 0 0 0 !important'
  },

  '@media all and (max-width: 450px)': {
    '.box:not(.is-grouped-multiline)': {
      padding: '1em'
    }
  }
});

export default class RefForm extends React.Component {
  constructor(props) {
    super(props);

    this.formRef = React.createRef();

    const { id = '',
      name = '',
      cedula = '',
      email = '',
      phone = '',
      phone_code = '',
      business_phone = '',
      business_phone_code = '',
      sex_orient = '',
      gender_ident = '',
      business_name = '',
      business_name_lc = '',
      categories = [],
      schedule = '',
      about_fem = '',
      about_support = '',
      location = {
        country: 'Costa Rica',
        codigo: '506',
        province: 'San José',
        address: '',
        maps_loc: '',
      },
      enabled = false,
      selectedProducts = [],
      selectedServices = [],
      description = '',
      social,
      create_date = new Date(Date.now()),
      logo = '',
      logoFile = {},
      exceededFileSize = false
    } = props.data || {};

    const displaySocial = {
      Website: '',
      Facebook: '',
      LinkedIn: '',
      Twitter: '',
      Instagram: '',
      Pinterest: '',
      Snapchat: '',
      WhatsAppCode: '',
      WhatsApp: '',
      Youtube: '',
      Vimeo: '',
    };

    this.state = {
      mounted: false,
      captchaOK: false,
      services: props.services.edges ? props.services.edges[0].node.name : props.services[0].name,
      products: props.products.edges ? props.products.edges[0].node.name : props.products[0].name,
      countries: props.countries.edges ? props.countries.edges.map(node => node.node) : props.countries,
      id,
      name,
      cedula,
      email,
      phone,
      phone_code,
      business_phone,
      business_phone_code,
      sex_orient,
      gender_ident,
      business_name,
      business_name_lc,
      business_name_lc_copy: business_name_lc,
      categories,
      schedule,
      description,
      about_fem,
      about_support,
      location,
      social: social || displaySocial,
      enabled,
      create_date,
      last_edit: new Date(Date.now()),
      logo,
      logoFile,
      exceededFileSize,
      errors: {
        email: false,
        name: false,
        cedula: false,
        cedula_format: false,
        phone: false,
        business_phone: false,
        categories: false,
        description: false,
        about_fem: false,
        about_support: false,
      },
      submitDisabled: false,
      selectedServices,
      selectedProducts,
      isMounted: false,
      isModalOpen: false,
      isModalTermsOpen: false,
      terms: false,
      submittedSuccess: false,
      business_name_lc_exists: false,
    }
  }

  clearForm = () => {

    const id = '',
      name = '',
      cedula = '',
      email = '',
      phone = '',
      phone_code = '506',
      business_phone = '',
      business_phone_code = '506',
      sex_orient = '',
      gender_ident = '',
      business_name = '',
      business_name_lc = '',
      categories = [],
      schedule = '',
      about_fem = '',
      about_support = '',
      location = {
        country: 'Costa Rica',
        codigo: '506',
        province: 'San José',
        address: '',
        maps_loc: '',
      },
      enabled = false,
      selectedProducts = [],
      selectedServices = [],
      description = '',
      logo = '',
      logoFile = {},
      social = {
        Website: '',
        Facebook: '',
        LinkedIn: '',
        Twitter: '',
        Instagram: '',
        Pinterest: '',
        Snapchat: '',
        WhatsApp: '',
        WhatsAppCode: '',
        Youtube: '',
        Vimeo: '',
      },
      submittedSuccess = false,
      isModalOpen = false,
      isModalTermsOpen = false,
      terms = false,
      business_name_lc_exists = false,
      exceededFileSize = false,
      errors = {
        email: false,
        name: false,
        cedula: false,
        cedula_format: false,
        phone: false,
        business_phone: false,
        phone_format: false,
        categories: false,
        description: false,
        about_fem: false,
        about_support: false,
        services: false,
        products: false,
        business_name_lc: false,
        business_name_empty: false,
        business_name_lc_exists: false
      };

    this.setState({
      id, name, cedula, email, phone, phone_code, business_phone, business_phone_code, sex_orient, gender_ident, business_name,
      categories, schedule, about_fem, about_support, location, enabled, selectedProducts,
      selectedServices, description, social, submittedSuccess, errors, isModalOpen, isModalTermsOpen,
      terms, logo, business_name_lc_exists, exceededFileSize, logoFile, business_name_lc
    })
  }

  verifyCallback = recaptchaToken => {
    this.setState({ captchaOK: true })
  }

  componentDidMount() {
    this.setState({ mounted: true });

    // setTimeout(() => {
    //   if (this.captcha) {
    //     this.captcha.execute();
    //   }
    // }, 1000);
  }

  UNSAFE_componentWillReceiveProps(nextProps, prevState) {
    if (this.state.mounted)
      this.setState({ ...nextProps.data, business_name_lc_copy: nextProps.data.business_name_lc });
  }

  validateField = e => {
    const emailRgx = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    const alphaHyphenRgx = new RegExp(/^[a-zA-Z0-9-]*$/);
    const numbersHyphenRgx = new RegExp(/^\d{1}-\d{4}-\d{4}$/);
    const numbersRgx = new RegExp(/^[0-9]*$/);
    // const maxChars = 15;
    // const maxCharsDesc = 3000;

    const { errors } = this.state;

    const field = e.currentTarget.name;

    switch (field) {
      case 'email':
        errors[field] = !emailRgx.test(this.state.email);
        break;
      // case 'cedula':
      //   errors['cedula_format'] = !numbersHyphenRgx.test(this.state.cedula);
      //   errors[field] = !this.state[field].trim();
      //   break;
      case 'phone':
        errors['phone_format'] = !numbersRgx.test(this.state.phone);
        errors[field] = !this.state[field].trim();
        break;
      case 'business_phone':
        errors['phone_format'] = !numbersRgx.test(this.state.business_phone);
        errors[field] = !this.state[field].trim();
        break;
      case 'categories':
        errors[field] = this.state.categories.length === 0;
        break;
      case 'business_name_lc':
        this.validateBusinessName(e.currentTarget.value)
          .then(exists => {
            this.setState({ business_name_lc_exists: exists }, () => {
              errors[field] = !alphaHyphenRgx.test(this.state.business_name_lc);
              errors['business_name_lc_empty'] = this.state.business_name_lc === '';
              errors['business_name_lc_exists'] = this.state.business_name_lc_exists;
              this.setState({ errors });
              return;
            })
          });
        break;
      default:
        // errors[`${field}-length`] = value && value.length > type === 'input' ? maxChars : maxCharsDesc;
        errors[field] = typeof this.state[field] === "string" && !this.state[field].trim();
    }

    this.setState({ errors });
  }

  validateForm = () => {
    const emailRgx = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    const alphaHyphenRgx = new RegExp(/^[a-zA-Z0-9-]*$/);
    const numbersHyphenRgx = new RegExp(/^\d{1}-\d{4}-\d{4}$/);
    const numbersRgx = new RegExp(/^[0-9]*$/);

    const errors = {
      email: !emailRgx.test(this.state.email),
      // maps_loc: !alphaHyphenRgx.test(this.state.location.maps_loc) && this.state.location.maps_loc !== '',
      name: this.state.name === "",
      cedula: this.state.cedula === "",
      // cedula_format: !numbersHyphenRgx.test(this.state.cedula),
      phone: this.state.phone === "",
      business_phone: this.state.business_phone === "",
      phone_format: !numbersRgx.test(this.state.phone),
      categories: this.state.categories.length === 0,
      services: this.state.categories.includes('service') && this.state.selectedServices.length === 0,
      products: this.state.categories.includes('product') && this.state.selectedProducts.length === 0,
      description: this.state.description === "",
      about_fem: this.state.about_fem === "",
      about_support: this.state.about_support === "",
      business_name_empty: this.state.business_name === '',
      business_name_lc: !alphaHyphenRgx.test(this.state.business_name_lc),
      business_name_lc_empty: this.state.business_name_lc === '',
      business_name_lc_exists: this.state.business_name_lc_exists,
      terms: this.state.terms === false && !this.props.data
    };
    const isDisabled = Object.keys(errors).some(x => errors[x] === true);
    this.setState({ errors, submitDisabled: isDisabled });
    return !isDisabled;
  }

  validateBusinessName = (name = '') => {
    return new Promise((resolve, reject) => {
      if (this.state.business_name_lc_copy === this.state.business_name_lc) resolve(false);
      const res = firestore.members.where('business_name_lc', '==', name.toLowerCase());
      res.get()
        .then(snapshot => {
          resolve(!snapshot.empty)
        })
        .catch(e => {
          reject(e);
        })
    })
  }

  handleChange = (e) => {
    switch (e.currentTarget.name) {
      case 'social':
        const { social } = this.state;
        social[e.currentTarget.dataset.social] = e.currentTarget.value
        this.setState({ social });
        break;
      case 'categories':
        let { categories } = this.state;
        const checked = e.currentTarget.checked;
        const type = e.currentTarget.dataset.category;

        if (checked) {
          if (!categories.includes(type))
            categories = [...categories, type];
        } else {
          if (categories.includes(type))
            categories = categories.filter(cat => cat !== type)
        }
        this.setState({ categories });
        break;
      case 'province':
      case 'address':
      case 'maps_loc':
        const location = this.state.location;
        location[e.currentTarget.name] = e.currentTarget.value;
        this.setState({ location });
        break;
      case 'country':
        const loc = this.state.location;
        loc.codigo = e.currentTarget.value;
        loc[e.currentTarget.name] = e.currentTarget.innerText;
        this.setState({ location: loc });
        break;
      case 'business_name_lc':
        const bname = e.currentTarget.value.toLowerCase();
        this.setState({ [e.currentTarget.name]: bname });
        break;
      default:
        let edit = this.state[e.currentTarget.name];
        edit = e.currentTarget.type === "checkbox" ? e.currentTarget.checked : e.currentTarget.value;
        this.setState({ [e.currentTarget.name]: edit });
    }
  }

  writeToFirestore = () => {
    // const { business_name } = this.state;
    // let business_name_lc = business_name.trim().replace(/\s+/g, '-').toLowerCase();
    // business_name_lc = encodeURI(business_name_lc);

    const data = {
      id: this.state.id,
      name: this.state.name,
      cedula: this.state.cedula,
      email: this.state.email,
      phone: this.state.phone,
      phone_code: this.state.phone_code,
      business_phone: this.state.business_phone,
      business_phone_code: this.state.business_phone_code,
      sex_orient: this.state.sex_orient,
      gender_ident: this.state.gender_ident,
      business_name: this.state.business_name,
      business_name_lc: this.state.business_name_lc.toLowerCase(),
      categories: this.state.categories,
      schedule: this.state.schedule,
      description: this.state.description,
      selectedProducts: this.state.selectedProducts,
      selectedServices: this.state.selectedServices,
      about_fem: this.state.about_fem,
      about_support: this.state.about_support,
      location: this.state.location,
      social: this.state.social,
      enabled: this.state.enabled,
      logo: this.state.logo,
      create_date: this.state.create_date,
      last_edit: this.state.last_edit
    }

    const user = firestore.auth.currentUser;
    if (user) {
      if (data.id) {
        const ref = firestore.members.doc(data.id);
        ref.update(data)
          .then(ref => this.setState({ submittedSuccess: true, isModalOpen: true }))
          .catch((e) => this.setState({ submittedSuccess: false, isModalOpen: true }));
      } else {
        firestore.store.collection('member').add(data)
          .then(ref => this.setState({ submittedSuccess: true, isModalOpen: true }))
          .catch((e) => this.setState({ submittedSuccess: false, isModalOpen: true }));
      }
    } else {
      firestore.auth.signInAnonymously()
        .then(() => {
          if (data.id) {
            const ref = firestore.members.doc(data.id);
            ref.update(data)
              .then(ref => this.setState({ submittedSuccess: true, isModalOpen: true }))
              .catch((e) => this.setState({ submittedSuccess: false, isModalOpen: true }));
          } else {
            firestore.store.collection('member').add(data)
              .then(ref => this.setState({ submittedSuccess: true, isModalOpen: true }))
              .catch((e) => this.setState({ submittedSuccess: false, isModalOpen: true }));
          }
        })
        .catch(error => {
          console.log(error.message);
        });
    }
  }

  handleSubmit = e => {
    e.preventDefault();

    if (!this.validateForm() || !this.state.captchaOK) {
      return;
    }

    if (this.state.logoFile.name) {
      this.uploadFile(this.state.logoFile)
        .then(url => {
          this.setState({ logo: url }, () => this.writeToFirestore())
        })
        .catch(err => {
          this.setState({ logo: '' }, () => this.writeToFirestore())
        });
    } else {
      this.writeToFirestore();
    }
  }

  closeModal = (e) => {
    e.preventDefault();

    if (this.state.submittedSuccess)
      this.clearForm();
    else
      this.setState({ isModalOpen: false })
  }

  closeTermsModal = (e) => {
    e.preventDefault();
    this.setState({ isModalTermsOpen: false });
  }

  onCaptchaChange = (value) => {
    let { submitDisabled } = this.state;
    submitDisabled = value === null;
    this.setState({ submitDisabled });
  }

  toggleServiceOrProduct = (item, isService) => {
    if (isService) {

      const { selectedServices } = this.state;

      if (!selectedServices.includes(item)) {
        this.setState({ selectedServices: [...selectedServices, item] });
      } else {
        this.setState(state => {
          const selectedServices = state.selectedServices && state.selectedServices.filter(service => service !== item)

          return {
            selectedServices,
          };
        });
      }
    } else {

      const { selectedProducts } = this.state;

      if (!selectedProducts.includes(item)) {
        this.setState({ selectedProducts: [...selectedProducts, item] });
      } else {
        this.setState(state => {
          const selectedProducts = state.selectedProducts && state.selectedProducts.filter(product => product !== item)

          return {
            selectedProducts,
          };
        });
      }
    }
  }

  uploadFile = () => {
    if (!this.state.logoFile.name) return;

    return new Promise((resolve, reject) => {
      const url = `https://api.cloudinary.com/v1_1/${process.env.GATSBY_CLOUDINARY_CLOUDNAME}/upload`;
      const fd = new FormData();
      fd.append("upload_preset", process.env.GATSBY_CLOUDINARY_PRESET);
      fd.append("tags", `empresarias/${this.state.business_name}`);
      fd.append("file", this.state.logoFile);
      const config = {
        headers: { "X-Requested-With": "XMLHttpRequest" },
        timeout: 3000
      };
      axios.post(url, fd, config)
        .then(res => {
          const response = res.data;
          const url = response.secure_url;
          resolve(url);
        })
        .catch(function (err) {
          console.error('err', err);
          reject(err);
        });
    })
  }

  handleFiles = files => {
    for (var i = 0; i < files.length; i++) {
      if (files[i].size <= 100000) {
        // this.uploadFile(files[i]);
        this.setState({ exceededFileSize: false, logoFile: files[i], logo: URL.createObjectURL(files[i]) });
      } else {
        this.setState({ exceededFileSize: true });
      }
    }
  };

  loadTermsConditions = () =>
    <div>
      <b><u>Descripción de REF</u></b>
      <p>
        La Red Económica Feminista (en adelante REF) es un espacio tanto físico como virtual en el cual generamos economía solidaria alternativa para dinamizar el mercado a través de contrataciones de bienes y servicios entre nosotras.
        Todas las personas, organizaciones o empresas que se encuentran en la REF se han ingresado de manera voluntaria y nadie les ha obligado a inscribirse.
      </p>

      <b><u>¿Quienes pueden ser parte de la REF?</u></b>
      <p>
        Pueden ser parte de la REF aquellos emprendimientos, empresas, trabajadoras independientes cuya productora o líder sea una o varias personas que se autodeterminen como mujeres cis, mujeres trans o personas no binarias.
        No necesariamente las personas parte de la REF deben identificarse como feministas, sin embargo, si deben cumplir con los principios feministas indicados en estos términos y condiciones.
        Pueden ser emprendimientos, empresas o trabajadoras independientes que se desempeñen tanto en la creación de bienes como de servicios.
      </p>

      <b><u>Del uso de la REF</u></b>
      <p>
        El uso de la REF será exclusivamente para contactarnos para adquirir bienes o servicios de otros emprendimientos, empresas o trabajadoras independientes.
        Quienes se inscriban en la REF están de acuerdo en que sus datos de contacto, proveídos para cumplir con la finalidad de la red, serán públicos en la página web de Chicas al Frente.  Los datos que se publican han sido dados por la persona interesada y nunca será información brindada por terceros.
        Quienes se inscriban en REF aseguran que los datos proporcionados son los propios o de la empresa / emprendimiento que representan y cuentan con el visto bueno de las personas encargadas.
      </p>

      <b><u>De los bienes y servicios ofrecidos en la REF</u></b>
      <p>
        La REF es una plataforma de contacto entre emprendimientos, empresas y trabajadoras independientes, bajo ninguna circunstancia se hace responsable de las negociaciones que deriven de este contacto.
        La REF no es propietaria ni se hace responsable de los bienes y servicios ofrecidos en la plataforma virtual o física.
        Bajo ninguna circunstancia se podrá ofrecer un bien o servicio que menoscabe la dignidad de las personas, ni los derechos humanos, especialmente los derechos humanos de las mujeres, personas de la comunidad LGBTTIQA, personas procedentes de zonas rurales, personas racializadas, personas en condición socioeconómica desfavorable y personas menores de edad.  Cuando hubiese una situación que pueda reñir con esta disposición tanto en la plataforma virtual, como en los encuentros, o actividades relacionadas con REF, debe ser reportado a la administración.
        Todo el contenido de este sitio respeta y busca no infringir las leyes de propiedad intelectual. En caso de que se encuentre o considere que un artículo o servicio está violando las leyes de propiedad intelectual, dar a aviso a info@chicasalfrente.com. El contenido será eliminado o modificado de inmediato.
      </p>

      <b><u>De la contratación de bienes y servicios</u></b>
      <p>
        REF es una plataforma para el contacto, todas las personas que utilicen la REF están en plena libertad de contratar o no el bien o servicio que requieran en determinado momento.  La contratación se realizará bajo los términos acordados entre el emprendimiento, la empresa, la persona profesional o la persona que realiza un bien o servicio y quien lo adquiere, REF ni las personas que la representan es mediadora en la contratación.
        REF se reserva el derecho de eliminar un emprendimiento, empresa o servicio profesional que haya sido acusado de estafa, de mala praxis o que riña en contra de los principios feministas descritos en estos términos y condiciones.
      </p>

      <b><u>Principios feministas de la REF</u></b>
      <p>
        La siguiente lista de principios y valores feministas fue construida en colectiva en el primer encuentro de la REF, realizado en julio del 2019.  Las personas dentro de la REF deben cumplir y velar porque todas las personas dentro de la REF cumplan con lo siguiente:
      </p>
      <ul>
        <li>Acabar con el capitalismo que destruye la vida y el planeta</li>
        <li>Acompañamiento</li>
        <li>Alegría</li>
        <li>Amistad</li>
        <li>Amor</li>
        <li>Autenticidad</li>
        <li>Autogestión</li>
        <li>Colectividad</li>
        <li>Comercio justo</li>
        <li>Compromiso</li>
        <li>Constancia</li>
        <li>Cooperación</li>
        <li>Diversidad</li>
        <li>Diversión</li>
        <li>Escucharme y respetar la voz de otras</li>
        <li>Hacer con placer</li>
        <li>Horizontalidad</li>
        <li>Igualdad</li>
        <li>Integridad</li>
        <li>Justicia ecológica y ambiental</li>
        <li>Luchar por los cumplimientos de los derechos de las mujeres</li>
        <li>Respeto</li>
        <li>Solidaridad</li>
        <li>Sororidad</li>
      </ul>

      <p>
        Al aceptar estos Términos y Condiciones acepta también recibir correos de parte del equipo de REF, a ser agregadas en la plataforma virtual y que el servicio o producto ofrecido por su actividad económica forme parte de publidad de la REF (publicidad sin fines lucrativos).  Del mismo modo, entiendo que queda a discreción del equipo REF incluir o retirar la actividad económica que ofrecen las empresarias de la plataforma virtual.
      </p>
    </div>

  displayTerms = () => {
    this.setState({ isModalTermsOpen: true });
  }

  render() {
    const { errors, social, services, products, location, countries } = this.state;

    const socialArray = social ? Object.keys(social) : [];
    const { maps_loc } = location;

    let lat = 9.9335647;
    let lng = -84.0792189;
    if (maps_loc) {
      const arr = maps_loc.split(',');
      if (arr.length > 1)
        lat = parseFloat(arr[0]);
      lng = parseFloat(arr[1]);
    }

    return (
      <section className={main}>
        {
          !this.props.data &&
          <SEO
            isBlogPost={false}
            postData={{
              description: '¡Buscá productos y servicios provenientes de chicas feministas o forma parte de la red!',
              title: 'Registro Red Económica Feminista',
              slug: '/registro-ref'
            }}
            postImage={'/img/ref-logo.jpg'}
          />
        }


        <section id="contact" className="section" >
          <Title title={this.props.data ? this.props.data.name : "REGISTRO RED ECONÓMICA FEMINISTA"} />

          <form ref={this.formRef} className="contact-input" onSubmit={this.handleSubmit.bind(this)}>
            <div className="box">
              <h2 className="has-text-centered">DATOS PERSONALES</h2>
              <p>Los campos marcados con (^) son privados y no aparecerán en el listado público. Los campos marcados con (*) son requeridos.</p>

              <div className="field">
                <label className="label">Nombre *</label>
                <div className="control">
                  <input
                    className={`input ${errors.name && 'is-danger'}`}
                    type="text"
                    name="name"
                    placeholder={'Nombre'}
                    autoComplete="name"
                    onChange={this.handleChange}
                    onBlur={this.validateField}
                    value={this.state.name}
                  />
                  <p className={`help is-danger ${errors.name ? 'show' : 'hide'}`}>Ingresá un nombre</p>
                </div>
              </div>

              <div className="field">
                <label className="label">Cédula ^</label>
                <div className="control">
                  <input
                    className={`input ${errors.cedula && 'is-danger'}`}
                    type="text"
                    name="cedula"
                    onChange={this.handleChange}
                    onBlur={this.validateField}
                    value={this.state.cedula}
                  />
                  <p className={`help is-danger ${errors.cedula ? 'show' : 'hide'}`}>Ingresá un número de cédula</p>
                  <p className={`help is-danger ${errors.cedula_format && !errors.cedula ? 'show' : 'hide'}`}>Ingresá un formato (ej. 0-0000-0000)</p>
                </div>
              </div>

              <div className="field">
                <label className="label">Email *</label>
                <div className="control">
                  <input
                    className={`input ${errors.email && 'is-danger'}`}
                    type="email"
                    name="email"
                    placeholder={'Email'}
                    autoComplete="email"
                    onChange={this.handleChange}
                    onBlur={this.validateField}
                    value={this.state.email}
                  />
                  <p className={`help is-danger ${errors.email ? 'show' : 'hide'}`}>El email no es válido</p>
                </div>
              </div>

              <div className="field">
                <label className="label">Teléfono ^</label>
                <div className="control is-flex">
                  <div className="select">
                    <select name="phone_code" value={this.state.phone_code} onChange={this.handleChange}>
                      {
                        countries.length && countries.sort().map(country => <option value={country.codigo} key={country.codigo}>{country.codigo}</option>)
                      }
                    </select>
                  </div>
                  <input
                    className={`input ${errors.phone && 'is-danger'}`}
                    type="text"
                    name="phone"
                    placeholder={'Teléfono'}
                    onChange={this.handleChange}
                    onBlur={this.validateField}
                    value={this.state.phone}
                  />
                  <p className={`help is-danger ${errors.phone ? 'show' : 'hide'}`}>Ingresá un número de teléfono</p>
                  <p className={`help is-danger ${errors.phone_format ? 'show' : 'hide'}`}>Ingresá solo números (ej. 88008800)</p>
                </div>
              </div>

              <div className="field">
                <label className="label">Identidad de Género ^</label>
                <div className="control">
                  <input
                    className="input"
                    type="text"
                    name="gender_ident"
                    onChange={this.handleChange}
                    value={this.state.gender_ident}
                  />
                </div>
              </div>

              <div className="field">
                <label className="label">Orientación Sexual ^</label>
                <div className="control">
                  <input
                    className="input"
                    type="text"
                    name="sex_orient"
                    onChange={this.handleChange}
                    value={this.state.sex_orient}
                  />
                </div>
              </div>
            </div>

            <div className="box">

              <h2 className="has-text-centered">DATOS DE LA EMPRESA</h2>
              <p>Todos los campos aparecerán en el listado público. Los campos marcados con (*) son requeridos.</p>
              <div className="field">
                <label className="label">Nombre de la empresa *</label>
                <div className="control">
                  <input
                    className={`input ${errors.business_name && 'is-danger'}`}
                    type="text"
                    name="business_name"
                    onChange={this.handleChange}
                    onBlur={this.validateField}
                    value={this.state.business_name}
                  />
                  <p className={`help is-danger ${errors.business_name ? 'show' : 'hide'}`}>Ingresá el nombre de la empresa</p>
                </div>
              </div>

              <div className="field">
                <label className="label">Teléfono de la empresa *</label>
                <div className="control is-flex">
                  <div className="select">
                    <select name="business_phone_code" value={this.state.business_phone_code} onChange={this.handleChange}>
                      {
                        countries.length && countries.sort().map(country => <option value={country.codigo} key={country.codigo}>{country.codigo}</option>)
                      }
                    </select>
                  </div>
                  <input
                    className={`input ${errors.business_phone && 'is-danger'}`}
                    type="text"
                    name="business_phone"
                    placeholder={'Teléfono Empresa'}
                    onChange={this.handleChange}
                    onBlur={this.validateField}
                    value={this.state.business_phone}
                  />
                  <p className={`help is-danger ${errors.business_phone ? 'show' : 'hide'}`}>Ingresá un número de teléfono</p>
                  <p className={`help is-danger ${errors.phone_format ? 'show' : 'hide'}`}>Ingresá solo números (ej. 88008800)</p>
                </div>
              </div>

              <div className="field">
                <label className="label">Nombre Perfil CAF *</label>
                <div className="control">
                  <input
                    className={`input ${errors.business_name_lc ? 'is-danger' : errors.business_name_lc_empty ? 'is-danger' : errors.business_name_lc_exists ? 'is-danger' : ''}`}
                    type="text"
                    name="business_name_lc"
                    onChange={this.handleChange}
                    onBlur={this.validateField}
                    value={this.state.business_name_lc}
                  />
                  <span className="help">Ingresá un nombre único para generar tu perfil de empresaria en CAF. Solo caracteres alfanuméricos y guiones.</span>
                  <p className={`help is-danger ${errors.business_name_lc_empty ? 'show' : 'hide'}`}>Ingresá un nombre de perfil</p>
                  <p className={`help is-danger ${errors.business_name_lc ? 'show' : 'hide'}`}>Solo se permiten caracteres alfanuméricos y guiones</p>
                  <p className={`help is-danger ${errors.business_name_lc_exists ? 'show' : 'hide'}`}>El nombre ya está registrado.</p>
                </div>
              </div>

              <div className="field">
                <label className="label">Categoría *</label>
                <div className="control prod-serv">
                  <label className="checkbox">
                    <input type="checkbox"
                      className="checkbox"
                      checked={this.state.categories.includes("service")}
                      name="categories"
                      data-category="service"
                      onChange={this.handleChange}
                      onBlur={this.validateField} />
                    Servicio
                  </label>
                  <label className="checkbox">
                    <input type="checkbox"
                      className="checkbox"
                      checked={this.state.categories.includes("product")}
                      name="categories"
                      data-category="product"
                      onChange={this.handleChange}
                      onBlur={this.validateField} />
                    Producto
                  </label>
                  <p className={`help is-danger ${errors.categories ? 'show' : 'hide'}`}>Seleccioná al menos una opción</p>
                </div>
              </div>

              <div className="field">
                <label className="label">Logo</label>
                <input type="file" className="file-upload" accept="image/*" style={{ outline: 'none' }} onChange={(e) => this.handleFiles(e.target.files)} />
                <p className={`help is-danger ${this.state.exceededFileSize ? 'show' : 'hide'}`}>El archivo no puede superar los 100kb</p>
                <p className={`help is-danger ${this.state.logo === 'error' ? 'show' : 'hide'}`}>No se pudo cargar el logo</p>
                {this.state.logo &&
                  <figure className="image is-128x128">
                    <img src={this.state.logo} alt="logo" />
                  </figure>}

              </div>

              <div className="field">
                <label className="label">Horario</label>
                <div className="control">
                  <input
                    className="input"
                    type="text"
                    name="schedule"
                    onChange={this.handleChange}
                    value={this.state.schedule}
                  />
                </div>
              </div>

              <div className="field">
                <label className="label">Descripción *</label>
                <div className="control">
                  <textarea
                    className={`textarea ${errors.description && 'is-danger'}`}
                    rows="5"
                    name="description"
                    onChange={this.handleChange}
                    onBlur={this.validateField}
                    value={this.state.description}
                  >
                  </textarea>
                  <p className={`help is-danger ${errors.description ? 'show' : 'hide'}`}>Ingresá una descripción</p>
                </div>
              </div>

              {
                this.state.categories.includes("service") && <><label className="label">Servicios</label>
                  <div className="box field is-grouped is-grouped-multiline">
                    <div className="buttons">
                      {
                        services.length && services.map((service, i) => <span key={i}
                          className={`button ${this.state.selectedServices.includes(service) ? 'selected service' : ''}`}
                          onClick={() => this.toggleServiceOrProduct(service, true)}>{service}</span>)
                      }
                    </div>
                    <p className={`help is-danger ${errors.services ? 'show' : 'hide'}`}>Seleccioná al menos una opción</p>
                  </div>
                </>
              }
              {
                this.state.categories.includes("product") && <> <label className="label">Productos</label>
                  <div className="box field is-grouped is-grouped-multiline">
                    <div className="buttons">
                      {
                        products.length && products.map((product, i) => <span key={i} className={`button ${this.state.selectedProducts.includes(product) ? 'selected' : ''}`} onClick={() => this.toggleServiceOrProduct(product, false)}>{product}</span>)
                      }
                    </div>
                    <p className={`help is-danger ${errors.products ? 'show' : 'hide'}`}>Seleccioná al menos una opción</p>
                  </div>
                </>
              }

              <label className="label">Redes sociales</label>
              <div id="dynamicInput">
                <div className="field">
                  <div className="columns">
                    <div className="column">
                      {
                        socialArray.length && socialArray.slice(0, socialArray.length / 2).map((k, i) =>
                          <div key={i} className="control">
                            <small>{k}</small>
                            <input type="text"
                              className="input social"
                              name="social"
                              placeholder={`${k} url`}
                              data-social={k}
                              value={social[k]}
                              onChange={this.handleChange}>
                            </input>
                          </div>
                        )
                      }
                    </div>
                    <div className="column">
                      {
                        socialArray.length && socialArray.slice(socialArray.length / 2, socialArray.length - 1).map((k, i) =>
                          <div key={i} className="control">
                            {
                              k === 'WhatsApp' ?
                                <>
                                  <small>{'WhatsApp'}</small>
                                  <div className="is-flex">

                                    <div className="select">
                                      <select name="social" className="social" data-social={'WhatsAppCode'} value={social['WhatsAppCode']} onChange={this.handleChange}>
                                        {
                                          countries.length && countries.sort().map(country => <option value={country.codigo} key={country.codigo}>{country.codigo}</option>)
                                        }
                                      </select>
                                    </div>
                                    <input type="text"
                                      className="input social"
                                      name="social"
                                      placeholder={'WhatsApp (solo números)'}
                                      data-social={k}
                                      value={social[k]}
                                      onChange={this.handleChange}>
                                    </input>
                                  </div>
                                </>
                                :
                                k !== 'WhatsAppCode' &&
                                <>
                                  <small>{k}</small>
                                  <input type="text"
                                    className="input social"
                                    name="social"
                                    placeholder={`${k} url`}
                                    data-social={k}
                                    value={social[k]}
                                    onChange={this.handleChange}>
                                  </input>
                                </>
                            }
                          </div>

                        )
                      }
                    </div>
                  </div>
                </div>
              </div>

              <div className="field location">
                <div className="control box is-grouped-multiline">
                  <label className="label">País</label>
                  <div className="field">
                    <div className="control">
                      <div className="select">
                        <select name="country" value={this.state.location.codigo} onChange={this.handleChange}>
                          {
                            countries.length && countries.sort().map(country => <option value={country.codigo} key={country.codigo}>{country.pais}</option>)
                          }
                        </select>
                      </div>
                    </div>
                  </div>

                  <label className="label">Provincia / Departamento</label>
                  <div className="field">
                    <div className="control">
                      <div className="select">
                        <select name="province" value={this.state.location.province} onChange={this.handleChange}>
                          {
                            countries.length && (countries.find(country => country.codigo === location.codigo)).provinces.sort()
                              .map(province => <option value={province} key={province}>{province}</option>)
                          }
                        </select>
                      </div>
                    </div>
                  </div>
                  <span className="help">En algunos países centroamericanos se utiliza el término Departamento para la división administrativa del país.</span>
                  <label className="label">Dirección</label>
                  <textarea
                    className="textarea"
                    rows="5"
                    name="address"
                    onChange={this.handleChange}
                    value={location.address}
                  >
                  </textarea>
                </div>
              </div>

              <div className="field">
                <label className="label">¿Considerás que tu emprendimiento es feminista? ¿Por qué? *</label>
                <div className="control">
                  <textarea
                    className={`textarea ${errors.about_fem && 'is-danger'}`}
                    rows="5"
                    name="about_fem"
                    onChange={this.handleChange}
                    onBlur={this.validateField}
                    value={this.state.about_fem}
                  >
                  </textarea>
                  <p className={`help is-danger ${errors.about_fem ? 'show' : 'hide'}`}>Ingresá una descripción</p>
                </div>
              </div>

              <div className="field">
                <label className="label">¿Apoyás a otras mujeres con tu emprendimiento? ¿De qué manera? *</label>
                <div className="control">
                  <textarea
                    className={`textarea ${errors.about_support && 'is-danger'}`}
                    rows="5"
                    name="about_support"
                    onChange={this.handleChange}
                    onBlur={this.validateField}
                    value={this.state.about_support}
                  >
                  </textarea>
                  <p className={`help is-danger ${errors.about_support ? 'show' : 'hide'}`}>Ingresá una descripción</p>
                </div>
              </div>
            </div>

            {
              this.props.data &&
              <div className="column is-4 notification is-danger">
                <label className="label">Desactivar/Activar perfil</label>
                <div className="control">
                  <label className="checkbox">
                    <input type="checkbox"
                      className="checkbox"
                      checked={this.state.enabled}
                      name="enabled"
                      onChange={this.handleChange} />
                    {this.state.enabled ? " Habilitada" : " Deshabilitada"}
                  </label>
                </div>
              </div>
            }

            <div className="field is-grouped-multiline submit-box">
              <div className="control submit">
                <button className="button is-primary" type="submit">Enviar</button>
                <br />
                <p className={`help is-danger ${this.state.submitDisabled ? 'show' : 'hide'}`}>Existen errores en el formulario</p>
                <br />
                <Link className="button is-small" to="/red-economica-feminista">Cancelar</Link>
              </div>
              {
                !this.props.data &&
                <div className="control submit">
                  <label className="checkbox">
                    <span>Estoy de acuerdo con los <a onClick={() => this.displayTerms()}>términos y condiciones</a></span>
                    <input type="checkbox"
                      name="terms"
                      checked={this.state.terms}
                      onChange={this.handleChange}
                      onBlur={this.validateField} />
                  </label>

                  <br />
                  <div className={`help is-danger ${errors.terms ? 'show' : 'hide'}`}>Debes leer y aceptar los términos y condiciones.</div>
                </div>

              }
            </div>

            <div className={`modal ${this.state.isModalOpen && 'is-active'}`}>
              <div className="modal-background"></div>
              <div className="modal-card">
                <header className="modal-card-head">
                  <p className="modal-card-title has-text-centered">{this.state.submittedSuccess ? 'Información enviada con éxito' : 'Ocurrió un error'}</p>
                  <button className="delete" aria-label="close-right" onClick={this.closeModal}></button>
                </header>
                <section className="modal-card-body">
                  {
                    this.state.submittedSuccess ? !this.props.data && '¡Muchas gracias!\n\nNuestras colaboradoras revisarán la información enviada y recibirás un correo cuando tu solicitud sea aprobada.' || this.props.data && '¡Información actualizada!' : 'No se ha podido enviar el formulario. Intentá de nuevo.'
                  }
                </section>
              </div>
            </div>

            <div className={`modal ${this.state.isModalTermsOpen && 'is-active'}`}>
              <div className="modal-background"></div>
              <div className="modal-card">
                <header className="modal-card-head">
                  <p className="modal-card-title has-text-centered">Términos y Condiciones</p>
                  <button className="delete" aria-label="close-right" onClick={this.closeTermsModal}></button>
                </header>
                <section className="modal-card-body">
                  {
                    this.loadTermsConditions()
                  }
                </section>
              </div>
            </div>

          </form>
          <GoogleReCaptchaProvider reCaptchaKey={process.env.GATSBY_GOOGLE_RECAPTCHAV3}>
            <GoogleReCaptcha onVerify={this.verifyCallback} />
          </GoogleReCaptchaProvider>
        </section>
      </section>


    )
  }
}
